<template>
  <header class="header">
    <Container
      :breakpoints="{
        xs: 0,
        sm: 480,
        md: 768,
        lg: 1024,
        xl: 1280,
      }"
    >
      <div class="top-menu-wrapper">
        <router-link to="/" class="logo-link">
          <div class="logo">
            <span :class="{ 'rotate-icon': isMenuOpen }" v-html="logoZerek" />
            <div class="logo-text">
              <h1>ZEREK</h1>
              <TextField tag="span" weight="700"
                >{{ $t(`landing.zerekTitlePart1`) }}
                <p class="zerek-title-block">
                  {{ $t("landing.zerekTitlePart2") }}
                </p>
              </TextField>
            </div>
          </div>
        </router-link>
        <div class="burger-menu" @click.stop="drawer = !drawer">
          <img src="@/assets/burger-menu.svg" class="burger-icon" />
        </div>

        <div class="top-menu">
          <!-- <a href="#" class="menu-link">
            <span :class="{ 'rotate-icon': isMenuOpen }" v-html="supportIcon" />
            <TextField :enableHover="true" hoverColor="#3F51B5" weight="500">{{
              $t(`landing.support`)
            }}</TextField>
          </a> -->
          <LanguageDropdown
            :languages="languages"
            @languageSelected="handleLanguageChange"
          />
          <a href="https://portal.zerek.edus.kz" class="center-link"
            ><TextField
              :enableHover="true"
              hoverColor="#3F51B5"
              weight="800"
              color="#0B43F1"
              >{{ $t(`landing.forCenters`) }}
            </TextField>
            <img src="@/assets/arrow-icon.svg" alt="Arrow"
          /></a>
          <Button
            type="outline"
            borderRadius="24px"
            height="36px"
            width="fit-content"
            v-if="!isAuthenticated"
            @click="goToLogin"
          >
            {{ $t(`landing.loginBtn`) }}
          </Button>
          <v-menu
            v-if="isAuthenticated && userInitials"
            bottom
            min-width="200px"
            rounded
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-btn icon x-large v-on="on">
                <v-avatar color="primary" size="40">
                  <span class="white--text text-h7">{{ userInitials }}</span>
                </v-avatar>
              </v-btn>
            </template>
            <v-card>
              <v-list-item-content class="justify-center">
                <div class="mx-auto text-center">
                  <v-avatar color="primary" size="40">
                    <span class="white--text text-h7">{{ userInitials }}</span>
                  </v-avatar>
                  <h5 class="mt-3" v-if="user">{{ user.name }}</h5>
                  <v-divider class="my-3"></v-divider>
                  <v-btn @click="goToLogin" depressed rounded text>
                    {{ $t(`landing.profileBtn`) }}
                  </v-btn>
                  <v-divider class="my-3"></v-divider>
                  <v-btn @click="logOut" depressed rounded text>
                    {{ $t(`landing.exitBtn`) }}
                  </v-btn>
                </div>
              </v-list-item-content>
            </v-card>
          </v-menu>
        </div>
      </div>

      <!-- Навигация -->
      <nav class="navbar">
        <ul class="navbar-menu">
          <li v-for="item in navItems" :key="item.name" class="navbar-item">
            <router-link
              :to="item.path"
              class="navbar-link"
              active-class="active-link"
            >
              <TextField
                tag="span"
                size="18"
                weight="500"
                color="#262626"
                hoverColor="#0056b3"
                :enableHover="true"
              >
                {{ $t(`landing.${item.name}`) }}
              </TextField>
            </router-link>
          </li>
        </ul>
      </nav>
    </Container>

    <v-navigation-drawer v-model="drawer" absolute temporary>
      <div class="drawer-head">
        <v-menu
          v-if="isAuthenticated && userInitials"
          bottom
          min-width="200px"
          rounded
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn icon x-large v-on="on">
              <v-avatar color="primary" size="40">
                <span class="white--text text-h7">{{ userInitials }}</span>
              </v-avatar>
            </v-btn>
          </template>
          <v-card>
            <v-list-item-content class="justify-center">
              <div class="mx-auto text-center">
                <v-avatar color="primary" size="40">
                  <span class="white--text text-h7">{{ userInitials }}</span>
                </v-avatar>
                <h5 class="mt-3" v-if="user">{{ user.name }}</h5>
                <v-divider class="my-3"></v-divider>
                <v-btn @click="goToLogin" depressed rounded text>
                  {{ $t(`landing.profileBtn`) }}
                </v-btn>
                <v-divider class="my-3"></v-divider>
                <v-btn @click="logOut" depressed rounded text>
                  {{ $t(`landing.exitBtn`) }}
                </v-btn>
              </div>
            </v-list-item-content>
          </v-card>
        </v-menu>
        <v-list-item v-else>
          <v-list-item-content>
            <Button
              type="outline"
              borderRadius="24px"
              height="36px"
              width="79px"
              v-if="!isAuthenticated"
              @click="goToLogin"
            >
              {{ $t(`landing.loginBtn`) }}
            </Button>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <LanguageDropdown :languages="languages" />
        </v-list-item>
      </div>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item link>
          <a href="#" class="center-link"
            ><TextField
              :enableHover="true"
              hoverColor="#3F51B5"
              weight="800"
              color="#0B43F1"
              >{{ $t(`landing.forCenters`) }}
            </TextField>
            <img src="@/assets/arrow-icon.svg" alt="Arrow"
          /></a>
        </v-list-item>
        <v-list-item link>
          <a href="#" class="menu-link">
            <!--            <img src="@/assets/support-icon.svg" alt="Support" />-->
            <span :class="{ 'rotate-icon': isMenuOpen }" v-html="supportIcon" />
            <TextField :enableHover="true" hoverColor="#3F51B5" weight="500">
              {{ $t(`landing.support`) }}
            </TextField>
          </a>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item v-for="item in navItems" :key="item.name">
          <router-link
            :to="item.path"
            class="navbar-link"
            active-class="active-link"
          >
            <TextField
              tag="span"
              size="18"
              weight="900"
              color="#262626"
              hoverColor="#0056b3"
              :enableHover="true"
            >
              {{ $t(`landing.${item.name}`) }}
            </TextField>
          </router-link>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <ProgressCircular v-if="isLoading" />
  </header>
</template>

<script>
import LanguageDropdown from "@/components/custom/LanguageDropdown.vue";
import { mapGetters } from "vuex";
import ProgressCircular from "@/components/custom/ProgressCircular.vue";
import Cookies from "js-cookie";
import supportIcon from "!!raw-loader!@/assets/support-icon.svg";
import logoZerek from "!!raw-loader!@/assets/logo_zerek.svg";

export default {
  components: {
    ProgressCircular,
    LanguageDropdown,
  },
  mounted() {
  },
  data: () => ({
    isLoading: false,
    supportIcon,
    logoZerek,
    languages: [
      { code: "kk", name: "Қазақша" },
      { code: "ru", name: "Русский" },
      // { code: "en", name: "English" },
    ],
    navItems: [
      { name: "popularCourses", path: "/popular-courses" },
      { name: "allCourses", path: "/courses" },
      { name: "tutoring", path: "/tutoring" },
      { name: "vacancies", path: "/vacancies" },
      { name: "favorites", path: "/courses/favorites" },
    ],
    isMobileMenuOpen: false,
    isMenuOpen: false,
    drawer: null,
    items: [
      { title: "Home", icon: "mdi-view-dashboard" },
      { title: "About", icon: "mdi-forum" },
    ],
  }),
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    ...mapGetters("auth", ["user"]),
    userInitials() {
      const name =
        typeof this.user === "string" ? this.user : this.user?.user?.name;
      if (!name) return "U";
      const parts = name.trim().split(/\s+/);
      return parts
        .slice(0, 2)
        .map((p) => p[0].toUpperCase())
        .join("");
    },
  },
  methods: {
    getInitials(fullName) {
      if (!fullName) return "";
      const parts = fullName.trim().split(/\s+/);
      const firstTwo = parts.slice(0, 2);
      return firstTwo.map((word) => word.charAt(0).toUpperCase()).join("");
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    logOut() {
      this.isLoading = true;
      this.$store.commit("auth/LOGOUT");

      setTimeout(() => {
        window.location.reload();
      }, 500);
    },
    goToLogin() {
      const firstEntry = Cookies.get("first_entry") === "true";
      const isAuthenticated = this.isAuthenticated;

      let targetRoute = isAuthenticated ? "/profile" : "/login";

      if (isAuthenticated && firstEntry) {
        targetRoute = "/registration";
      }

      if (this.$route.path === targetRoute) return;

      this.$router.replace(targetRoute);
    },
    handleLanguageChange(selectedLanguage) {
      console.log("Selected language:", selectedLanguage);
    },
  },
};
</script>

<style scoped>
.container-md {
  max-width: 800px !important;
  margin: 0 auto !important;
}
.zerek-title-block {
  margin-bottom: 0 !important;
}
::v-deep .theme--light.v-navigation-drawer .v-divider {
  margin: 12px 0;
}
.navbar-link.active-link {
  font-weight: bold;
  border-bottom: 2px solid #0056b3;
  margin-top: 5px;
}
.navbar-link.active-link span {
  color: #0056b3 !important;
}
.drawer-head {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.burger-menu {
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.3s ease;
  display: none;
}
.burger-menu:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.burger-menu:active {
  background-color: rgba(0, 0, 0, 0.2);
}
.burger-icon {
  width: 24px;
  height: auto;
}
.top-menu-wrapper {
  display: flex;
  justify-content: space-between;
}
.header {
  background-color: #f5f8ff;
  padding: 15px 0 5px;
  border-bottom: 1px solid #eaeaea;
}
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.logo {
  display: flex;
  align-items: center;
  gap: 10px;
}

::v-deep.logo span svg {
  width: 40px;
  height: 40px;
}
.logo-text h1 {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  color: #000;
}
.logo-text span {
  font-size: 16px;
  color: #666;
}
.top-menu {
  display: flex;
  align-items: center;
  gap: 20px;
}
.menu-link {
  display: flex;
  align-items: center;
  gap: 5px;
}
.language-dropdown {
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
}
.center-link {
  display: flex;
  align-items: center;
  gap: 5px;
}
.login-btn {
  background-color: #ffffff;
  border: 2px solid #007bff;
  color: #007bff;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
}
.login-btn:hover {
  background-color: #007bff;
  color: #ffffff;
}
.navbar-menu {
  display: flex;
  justify-content: center;
  list-style: none;
  gap: 60px;
  padding: 0;
  margin: 0;
}
.navbar {
  padding: 30px 20px 0;
}
.navbar-item {
  position: relative;
}
.navbar-link {
  text-decoration: none;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  position: relative;
  transition: color 0.3s ease;
}
.navbar-link:hover {
  color: #0056b3;
}
.navbar-link::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #0056b3;
  transition: width 0.3s ease;
}

.navbar-link:hover::after {
  width: 100%;
}
.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .container {
    flex-direction: column;
    align-items: flex-start;
  }
  .burger-menu {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .top-menu {
    display: none;
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    background-color: #f5f8ff;
    padding: 10px;
    width: 100%;
  }
  .navbar {
    display: none;
  }
  .mobile-menu-btn {
    display: block;
    align-self: flex-end;
  }
  .mobile-visible {
    display: flex;
  }
}
</style>
